import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconCloseCircleWhite({
	size = "100",
	...props
}: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<mask id="a" width={24} height={24} x={0} y={0}>
					<circle cx={12} cy={12} r={10} fill="#FFF" />
					<path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
				</mask>
			</defs>
			<path fill="#FFF" d="M0 0h24v24H0z" mask="url(#a)" />
		</svg>
	);
}
